import {omit} from 'remeda';

import {AddressType} from 'desktop/types/addressType';

import {AssociationsResultType} from '../../../decomposeAllAddressesByComponents/utils/applyAssociations/applyAssociations';

/**
 * Returns simplified customer address used for validation comparison
 * @param {AssociationsResultType} address - Received customer address
 * @returns {Omit<AddressType, 'addressID' | 'email'>} - Simplified address object that suitable to comparison
 */
export const simplifyAddressObject = (
    address: AssociationsResultType,
): Omit<AddressType, 'addressID' | 'email'> => {
    const simplifyAddress = Object.entries(address).reduce(
        (acc, [key, value]) => ({...acc, [key]: value.value as string}),
        {} as {[key: string]: string},
    );
    // @ts-expect-error
    return omit(simplifyAddress, ['addressID', 'email']);
};
